<template>
  <div class="s-wizard__questions__body">
    <div class="question-row">
      <label class="question-text--inline">
        {{ dictionary.step1AgeLabel }}
      </label>
      <input
        v-model="age"
        class="question-input--text"
        type="text"
        :placeholder="dictionary.step1AgePlaceholder"
        @change="enableNextBtn" />
      <label class="question-text--inline">
        {{ dictionary.step1IncomeLabel }}
      </label>
      <input
        v-model="income"
        class="question-input--text"
        type="text"
        :placeholder="dictionary.step1IncomePlaceholder"
        @change="enableNextBtn" />
    </div>
    <div class="question-row">
      <label class="question-text--inline">
        {{ dictionary.step1InvestTypeLabe }}
      </label>
      <select
        id="investType"
        v-model="selectedOption"
        class="question-select form-select"
        name="investType"
        @change="showMore(selectedOption)">
        <option value="" disabled selected>
          {{ dictionary.step1InvestTypePlaceholder }}
        </option>
        <option
          v-for="(answer, index) in formatedData"
          :key="index"
          :value="answer.id"
          v-html="answer.text"></option>
      </select>
    </div>

    <template v-if="hasShowMore">
      <div class="question-row">
        <label class="question-text--inline">
          {{ dictionary.step1InvestAmountLabel }}
        </label>
        <input
          v-model="investAmount"
          class="question-input--text"
          type="text"
          :placeholder="dictionary.step1InvestAmountPlaceholder"
          style="flex: 1"
          @change="enableNextBtn" />
      </div>
      <div class="question-row">
        <label class="question-text--inline">
          {{ dictionary.step1InvestDurationLabel }}
        </label>
        <input
          v-model="investDuration"
          class="question-input--text"
          type="text"
          :placeholder="dictionary.step1InvestDurationPlaceholder"
          style="flex: 1"
          @change="enableNextBtn" />
        <label class="question-text--inline">
          {{ dictionary.step1InvestDurationSuffix }}
        </label>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    stepData: {
      required: true,
      type: Array,
    },
    currentStep: {
      required: true,
      type: Number,
    },
  },
  emits: ['gather-data', 'enable-next-btn'],
  data() {
    return {
      age: '',
      income: '',
      selectedOption: '',
      investAmount: '',
      investDuration: '',
      hasShowMore: false,
    }
  },

  computed: {
    formatedData() {
      return this.stepData[0].answers
    },
  },
  mounted() {
    // this.stepData = stepData
    // console.log(this.stepData)
  },

  methods: {
    showMore(answer) {
      const showExtra = this.stepData[0].answers.find(
        (item) => item.id === answer
      ).hasMore

      this.hasShowMore = showExtra

      this.enableNextBtn()
    },

    gatherData() {
      this.$emit('gather-data', {
        age: this.age,
        income: this.income,
        selectedOption: this.selectedOption,
        investAmount: this.investAmount,
        investDuration: this.investDuration,
      })
    },
    enableNextBtn() {
      if (
        this.hasShowMore &&
        this.age &&
        this.income &&
        this.selectedOption &&
        this.investAmount &&
        this.investDuration
      ) {
        this.$emit('enable-next-btn', true)
        this.gatherData()

        return
      }

      if (!this.hasShowMore && this.age && this.income && this.selectedOption) {
        this.$emit('enable-next-btn', true)
        this.gatherData()
        return
      }
      this.$emit('enable-next-btn', false)
    },
  },
}
</script>
